import { fork } from 'redux-saga/effects';
import { api } from 'redux/helpers';
import * as utils from 'utils/api/configuration/team';
import * as actions from './actions';


export default function* team() {
  yield fork(api(actions.GET_LIST, actions.getList, utils.getList));
}



// WEBPACK FOOTER //
// ../redux/store/services/api/configuration/team/saga.js